// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/plugins/manualColumnMove/manualColumnMove.css
// module id = 480
// module chunks = 0